import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { DispatchT } from '../../data-mediation/types/flux';
import { useConfig, useDispatch, useQuestion } from '../../data-mediation';

interface HeaderT {
  dispatch: DispatchT;
  show: boolean;
  enableAnimations: boolean;
  children: React.ReactNode;
}

const HeaderContent = ({
  dispatch,
  show,
  enableAnimations,
  children,
}: HeaderT) => {
  return (
    <Box
      alignItems="center"
      justifyContent="center"
      width={1}
      left={0}
      position="absolute"
      zIndex={2}
      data-testid="sfinx-header"
      extend={({ theme }) => ({
        transition: `transform ${
          enableAnimations ? theme.durations[1] : 0
        }s ease`,
        transform: `translateY(${show ? 0 : '-90px'})`,
      })}
      onClick={() =>
        dispatch({
          type: 'SET_PRESENTATION_SETTING',
          payload: { key: 'showHeader', value: !show },
        })
      }
    >
      {children}
    </Box>
  );
};

const Header = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const { enableAnimations } = useConfig();
  const q = useQuestion();
  const showHeader = q ? !q.hide_voting_instructions : true;

  return (
    <HeaderContent
      data-id="header-content"
      show={showHeader}
      dispatch={dispatch}
      enableAnimations={enableAnimations}
    >
      {children}
    </HeaderContent>
  );
};

export default Header;
